import axios, { AxiosInstance } from 'axios';
import { Store } from 'redux';

let store: Store | null = null;

export const setStore = (reduxStore: Store) => {
	store = reduxStore;
};

interface ICustomAxiosRequest extends AxiosInstance {
	unauthorized: boolean; // Voliteľná vlastnosť `unauthorized`
}

const apiClient: ICustomAxiosRequest = axios.create({
	baseURL: import.meta.env.VITE_API_URL,
	timeout: 30000,
	headers: {
		'Content-Type': 'application/json',
		// Authorization: "Bearer my-token",
	},
}) as ICustomAxiosRequest;

apiClient.unauthorized = true;

apiClient.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		// Môžeš spracovať chyby (napr. presmerovanie pri 401)
		if (error.response?.status === 401) {
			// Spracovanie odhlásenia alebo obnovenie tokenu
		}
		return Promise.reject(error);
	}
);

export default apiClient;
